<template>
    <button ref="speakerNextButton" @click="pickSpeaker">{{ buttonText }}</button>
</template>

<style lang="scss"></style>

<script>
    import { AppState } from '@/app/data';

    export default {
        data()
        {
            return {
                buttonText: 'Gaan met die\xa0🍌'
            };
        },

        computed: {
            currentStatus()
            {
                return this.$store.getters['status/currentStatus'];
            },

            findActiveSpeaker()
            {
                return this.$store.getters['people/findActiveSpeaker'];
            }
        },

        watch: {
            currentStatus: function( newValue )
            {
                if( newValue === AppState.BUSY )
                {
                    this.changeButtonAndTitle();
                }

                if( newValue === AppState.ENDED )
                {
                    this.buttonText = 'Kyan, plaats.\xa0🐕';
                }
            }
        },

        methods: {
            pickSpeaker()
            {
                // Pick a speaker:
                this.$store.dispatch( 'people/pickRandomSpeaker' );
            },

            changeButtonAndTitle()
            {
                let nextDocumentTitles = [ 'Mr. Ynk Namen Kiezer', 'Mr. Ynk Namepicker', 'Mr. Ynk Namenkeusmaker', 'Mr. Ynk Neempikker', 'Mr. Ynk Namenrouletteslet', 'Name Picker NT' ];
                let nextDocumentTitle = nextDocumentTitles[Math.floor( Math.random() * nextDocumentTitles.length )];
                document.title = nextDocumentTitle;

                let nextButtonTexts = [ 'Kyan, volgende!', 'Kyan, verder!', 'Kyan, go!', "Kyan, let's go!", 'Kyan, kaartje?', 'Kyan, följande!' ];
                let nextButtonText = nextButtonTexts[Math.floor( Math.random() * nextButtonTexts.length )];
                this.buttonText = nextButtonText;
            }
        }
    };
</script>
